import React from "react";
import {
  Flex,
  DialogContent,
  DialogTitle,
  Modal,
  Icon,
  FieldTextGroup,
  Text
} from "@theorgchartdev/storybook";
import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { enumDateTimeDisplayOptions } from "@coreapp/constants";
import { getPlanOwners } from "@/Utils/Plan/planOwnerHelpers";

const createAdditionalFieldsText = (fields, isPositionPlan = false) => {
  if (!fields || (fields.holder.length === 0 && fields.position.length === 0)) {
    return appstr("No additional fields");
  }

  const holderFields = fields.holder.length > 0 ? fields.holder.join(", ") : "";
  if (!isPositionPlan) {
    return holderFields;
  }
  const positionFields = fields.position.length > 0 ? fields.position.join(", ") : "";

  return (
    <>
      {holderFields ? (
        <p>
          <Text element="span" modifier="medium" size="small">
            {`${appstr("Employee fields")}: `}
          </Text>
          <Text type="body" element="span" size="small">
            {holderFields}
          </Text>
        </p>
      ) : null}
      {positionFields ? (
        <p>
          <Text element="span" modifier="medium" size="small">
            {`${appstr("Position fields")}: `}
          </Text>
          <Text type="body" element="span" size="small">
            {positionFields}
          </Text>
        </p>
      ) : null}
    </>
  );
};
const AboutPlanModal = ({ show, onClose, curPlan, ...props }) => {
  if (!show) return null;
  let wsMgr = StateLib.GetWSMgr();
  var dataSource = -1;
  var docMgr = wsMgr.GetDocMgr();
  var curDoc = wsMgr.GetDoc();
  if (docMgr) {
    var iWiz = docMgr.GetIWizDataRefresh();
    if (iWiz) {
      dataSource = iWiz.GetDataSource();
    }
  }
  let planName = curPlan?.name;
  planName = planName + " (" + curPlan?.status + ")";
  let planDescription = curPlan?.description;
  if (!planDescription || planDescription.length === 0)
    planDescription = appstr("No plan description");

  const isPositionPlan = curPlan?.isPositions ?? false;
  const planOwners = getPlanOwners(curPlan?.users || []);
  let planOwnerDisplay =
    planOwners.length > 0
      ? planOwners.map(o => o.displayName || o.name).join(", ")
      : curPlan?.owner;
  let planTopBox = curPlan?.topBoxID;
  let planLevels = curPlan?.levels;
  let planSync = curPlan?.syncDate;
  planSync = new Date().convertUTCDateToLocalDateString(
    planSync,
    null,
    null,
    enumDateTimeDisplayOptions.shortdatetime
  );
  let planMod = curPlan?.modDate;
  planMod = new Date().convertUTCDateToLocalDateString(
    planMod,
    null,
    null,
    enumDateTimeDisplayOptions.shortdatetime
  );
  let planSource = curPlan?.chartID;
  let charts = wsMgr?.fOrgInfo.fMasterChartList;
  planSource = charts[planSource].name;
  const planAdditionalFieldsText = createAdditionalFieldsText(curPlan?.fields, isPositionPlan);
  let planMetrics = curPlan?.metrics;
  let metricsLabel = [];
  if (planMetrics) {
    var metricsKey = appstr("Metrics") + " (" + planMetrics.length + "): ";
    metricsLabel = planMetrics
      .map(function (item) {
        return item.fieldID;
      })
      .join(", ");
  }
  let planSharedUsers = curPlan?.users;
  var sharedUsers = [];

  if (planSharedUsers) sharedUsers = planSharedUsers;

  if (sharedUsers.length > 0) {
    sharedUsers = sharedUsers.filter(function (item) {
      return item.role !== "owner";
    });
  }

  var sharedUsersLabel = "";
  if (sharedUsers.length > 0) sharedUsersLabel = sharedUsers.length.toString();
  else sharedUsersLabel = appstr("None");

  const aboutdata = [
    { field: appstr("Name"), value: planName },
    { field: appstr("Description"), value: planDescription },
    { field: appstr("owner"), value: planOwnerDisplay },
    { field: appstr("topbox"), value: planTopBox },
    { field: appstr("Levels"), value: planLevels },
    { field: appstr("Last Synchronized"), value: planSync },
    { field: appstr("Last Modified"), value: planMod },
    { field: appstr("Source chart"), value: planSource },
    { field: appstr("Additional fields"), value: planAdditionalFieldsText },
    { field: metricsKey, value: metricsLabel },
    { field: appstr("Shared users"), value: sharedUsersLabel }
  ];

  return (
    <CentralizedModalContainer show={show}>
      <Modal
        id="about-plan-modual"
        show={show}
        centerScreen={true}
        fullScreen={false}
        minWidth={"large"}
        maxWidth={"large"}
        customStyle={{ minHeight: "400px", maxHeight: "500px" }}
        className={"oc-modal-content"}
      >
        <DialogTitle divider={true} onClose={() => onClose()}>
          <span className={"ocn-explorer-icon-label"}>
            <Icon size={"medium"} name={"circle-info"} />
            {appstr("About Plan")}
          </span>
        </DialogTitle>
        <DialogContent customContentClass={"oc-modal-content-container"}>
          <Flex className={"oc-modal-content"} direction={"column"} gap={"8px"} height={"100%"}>
            <FieldTextGroup data={aboutdata} size={"medium"} />
          </Flex>
        </DialogContent>
      </Modal>
    </CentralizedModalContainer>
  );
};

export default AboutPlanModal;
